import { render, staticRenderFns } from "./InteractionLogForm.vue?vue&type=template&id=2179d4f7&scoped=true"
import script from "./InteractionLogForm.vue?vue&type=script&lang=js"
export * from "./InteractionLogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179d4f7",
  null
  
)

export default component.exports